import css from './web.scss'
import React, { FC, useLayoutEffect, useState, useEffect } from 'react'
import cls from 'classnames'
import isMobile from 'ismobilejs'
import { getQuery } from '@douban/fe-utils'
import UA from '@douban/rexxar-common/es/assets/js/ua'
import { appendQuery } from '@douban/rexxar-common/es/assets/js/uri'

import { IS_DEV, SOURCE_QRCODE_URL, DISPATCH_URL } from '@src/common/const'
import { configWechatSharing } from '@src/common/utils/wechat'
import { generateQR } from '@src/common/utils/qrcode';
import { useFlexible } from '@src/common/utils/flexible'
import Log from '@src/common/utils/log'

const Web: FC = () => {
  const [ qrcode, setQrcode ] = useState<string|undefined>()

  if (isMobile().any) {
    useFlexible()
  }

  useLayoutEffect(() => {
    document.title = `参与活动，一起吃蛋糕吧！`
  }, [])

  useEffect(() => {
    Log('enter_c9_page', {
      'uri': window.location.href,
      'type': isMobile().any ? 'mobile' : 'web',
    })

    // 微信内分享
    if (UA.isWeixin() || IS_DEV) {
      const metaTitle = document.querySelector('meta[property="og:title"]')
      const metaDesc = document.querySelector('meta[property="og:description"]')

      const ogTitle = metaTitle ? metaTitle.getAttribute('content') : ''
      const ogDesc = metaDesc ? metaDesc.getAttribute('content') : ''

      configWechatSharing({
        link: DISPATCH_URL,
        title: ogTitle,
        desc: ogDesc || ''
      })
    }
  }, [])

  let qrcodeUrl = SOURCE_QRCODE_URL
  const source = getQuery(window.location.href).source
  if (source) {
    qrcodeUrl = appendQuery(qrcodeUrl, {
      source
    })
  }

  // if (IS_DEV) {
  //   console.log('qrcodeUrl - ', qrcodeUrl)
  //   console.log('DISPATCH_URL - ', DISPATCH_URL)
  // }

  generateQR(qrcodeUrl, {
    width: 240,
    margin: 0,
  }).then(qr => setQrcode(qr))

  return (
    <div className={ cls(css.app, {
      [css.mobile]: isMobile().any
    })}>
      <div className={ css.main }>
        { isMobile().any ? (
          <a href={ DISPATCH_URL } className={ css.dispathBtn }>打开豆瓣，一起吃蛋糕</a>
        ) : (
          <div className={ css.qrWrap }>
            <img className={ css.qr }
              src={ qrcode }
            />
          </div>
        ) }
      </div>
    </div>
  )
}

export default Web
